'use strict';

var initProductTilejs = require('../search/search').initProductTilejs;
/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon) {
  $.spinner().stop();
  if (icon.hasClass('red')) {
    icon.removeClass('red');
  } else {
    icon.addClass('red');
  }
  $('.add-to-wishlist-messages').append(data.msg);
}

$(window).on('load', function () {
  var $fields = $('.bottom-line-items-container').find('.product-related-fields-column').find('.product-related-fields-item-title');

  if ($('.aggregated-product-related-fields').length > 0) {
    $('.aggregated-product-related-fields').addClass('d-block');
  }

  $fields.each(function () {
    if ($(this).html() == 'Fit') {
      var fitvalue = $(this).closest('.product-related-fields-item').find('.product-related-fields-item-value').text().replace(/\/$/, "").trim().toLowerCase();

      var fithtml = '<div class="row yotpo-size-bars">' +
        (fitvalue === "runs small" ? '<div class="run-small size-bar size-bar-filled"><span class="size-bar"></span><span class="size-text size-bar-filled">Run Small</span></div>' : '<div class="run-small size-bar"><span class="size-bar"></span><span class="size-text">Run Small</span></div>') +
        '<div class="yotpo-score-divider"></div>' +
        (fitvalue === "true to size" ? '<div class="true-to-size size-bar size-bar-filled"><span class="size-bar"></span><span class="size-text size-bar-filled">True to Size</span></div>' : '<div class="true-to-size size-bar"><span class="size-bar"></span><span class="size-text">True to Size</span></div>') +
        '<div class="yotpo-score-divider"></div>' +
        (fitvalue === "runs large" ? '<div class="run-big size-bar size-bar-filled"><span class="size-bar"></span><span class="size-text size-bar-filled">Run Big</span></div>' : '<div class="run-big size-bar"><span class="size-bar"></span><span class="size-text">Run Big</span></div>')

      $(this).closest('.product-related-fields-item').find('.product-related-fields-item-value').addClass('d-none');
      $(this).closest('.product-related-fields-item').append(fithtml);
    } else if ($(this).html() == 'Comfort') {
      var comfortvalue = $(this).closest('.product-related-fields-item').find('.product-related-fields-item-value').text().replace(/\/$/, "").trim().toLowerCase();

      var comforthtml = '<div class="row yotpo-size-bars">' +
        (comfortvalue === "not comfortable" ? '<div class="not-comfortable size-bar size-bar-filled"><span class="size-bar"></span><span class="size-text size-bar-filled">Not Comfortable</span></div>' : '<div class="not-comfortable size-bar"><span class="size-bar"></span><span class="size-text">Not Comfortable</span></div>') +
        '<div class="yotpo-score-divider"></div>' +
        (comfortvalue === "somewhat comfortable" ? '<div class="somewhat-comfortable size-bar size-bar-filled"><span class="size-bar"></span><span class="size-text size-bar-filled">Somewhat Comfortable</span></div>' : '<div class="somewhat-comfortable size-bar"><span class="size-bar"></span><span class="size-text">Somewhat Comfortable</span></div>') +
        '<div class="yotpo-score-divider"></div>' +
        (comfortvalue === "very comfortable" ? '<div class="very-comfortable size-bar size-bar-filled"><span class="size-bar"></span><span class="size-text size-bar-filled">Very Comfortable</span></div>' : '<div class="very-comfortable size-bar"><span class="size-bar"></span><span class="size-text">Very Comfortable</span></div>')

      $(this).closest('.product-related-fields-item').find('.product-related-fields-item-value').addClass('d-none');
      $(this).closest('.product-related-fields-item').append(comforthtml);
    }
  });
});

module.exports = {
  addToWishlist: function () {
    $('.js-add-to-wish-list').on('click', function (e) {
      e.preventDefault();

      var addUrl = $(this).data('href');
      var removeUrl = $(this).data('removeurl');
      var icon = $(this).find($('i'));
      var pid = $(this).closest('.product-detail').find('.product-id').html();
      var optionId = $(this)
        .closest('.product-detail')
        .find('.product-option')
        .attr('data-option-id');
      var optionVal = $(this)
        .closest('.product-detail')
        .find('.options-select option:selected')
        .attr('data-value-id');
      var addToWishlist = true;
      optionId = optionId || null;
      optionVal = optionVal || null;
      if (!pid) {
        return;
      }

      if (icon.hasClass('red')) {
        addToWishlist = false;
      }

      if (addToWishlist) {
        $.ajax({
          url: addUrl,
          type: 'post',
          dataType: 'json',
          data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal,
          },
          success: function (data) {
            displayMessageAndChangeIcon(data, icon);
          },
          error: function (err) {
            displayMessageAndChangeIcon(err, icon);
          },
        });
      } else {
        $.ajax({
          url: removeUrl,
          type: 'get',
          dataType: 'json',
          data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal,
          },
          success: function (data) {
            displayMessageAndChangeIcon(data, icon);
          },
          error: function (err) {
            displayMessageAndChangeIcon(err, icon);
          },
        });
      }
    });
  },

  updateAttributesAndDetails: function () {
    $('body').on('product:statusUpdate', function (e, data) {
      var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

      $productContainer
        .find('.description-and-detail .product-attributes')
        .empty()
        .html(data.attributesHtml);

      if (data.shortDescription) {
        $productContainer
          .find('.description-and-detail .description')
          .removeClass('hidden-xl-down');
        $productContainer
          .find('.description-and-detail .description .content')
          .empty()
          .html(data.shortDescription);
      } else {
        $productContainer
          .find('.description-and-detail .description')
          .addClass('hidden-xl-down');
      }

      if (data.longDescription) {
        $productContainer
          .find('.description-and-detail .details')
          .removeClass('hidden-xl-down');
        $productContainer
          .find('.description-and-detail .details .content')
          .empty()
          .html(data.longDescription);
      } else {
        $productContainer
          .find('.description-and-detail .details')
          .addClass('hidden-xl-down');
      }
    });
  },

  showSpinner: function () {
    $('body').on(
      'product:beforeAddToCart product:beforeAttributeSelect',
      function () {
        if (!$('.modal.show .modal-content').length) {
          $.spinner().start();
        }
      }
    );
  },
  updateAttribute: function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
      if ($('.product-detail>.bundle-items').length) {
        response.container.data('pid', response.data.product.id);
        response.container.find('.product-id').text(response.data.product.id);
      } else if ($('.product-set-detail').eq(0)) {
        response.container.data('pid', response.data.product.id);
        var $productIdElements = response.container.find('.product-id');
        if ($productIdElements.length > 1) {
          $productIdElements.each(function () {
            // update main product pid and not of co-ordinating items
            if (!$(this).parents('.coordinating-product').length) {
              $(this).text(response.data.product.id);
            }
          });
        } else {
          response.container.find('.product-id').text(response.data.product.id);
        }
      } else {
        $('.product-id').text(response.data.product.id);
        $('.product-detail:not(".bundle-item")').data(
          'pid',
          response.data.product.id
        );
      }
    });
  },
  updateAddToCart: function () {
    $('body').on('product:updateAddToCart', function (e, response) {
      // update local add to cart (for sets)
      $('button.add-to-cart', response.$productContainer).attr(
        'disabled',
        !response.product.readyToOrder || !response.product.available
      );

      var enable = $('.product-availability')
        .toArray()
        .every(function (item) {
          return $(item).data('available') && $(item).data('ready-to-order');
        });
      $('button.add-to-cart-global').attr('disabled', !enable);
    });
  },
  updateAvailability: function () {
    $('body').on('product:updateAvailability', function (e, response) {
      $('div.availability', response.$productContainer)
        .data('ready-to-order', response.product.readyToOrder)
        .data('available', response.product.available);

      $('.availability-msg', response.$productContainer)
        .empty()
        .html(response.message);

      if (!response.message) {
        $('.availability-msg').addClass('hide');
      } else {
        $('.availability-msg').removeClass('hide');
      }

      $('.js-availability-msg', response.$productContainer).attr(
        'data-inventory',
        response.product.availability.type
      );

      if (!response.product.availability.label) {
        $('.js-availability-msg-label').addClass('hide');
      } else {
        $('.js-availability-msg-label').removeClass('hide');
      }
      $('.js-availability-msg-label', response.$productContainer)
        .empty()
        .html(response.product.availability.label);

      var openModal = $('body').hasClass('modal-open');
      var availabilityType = response.product.availability.type;
      if (!openModal && $('.js-availability-msg-personalize').length) {
        if (
          response.product.productType != 'master' &&
          (response.product.availability.messages.length > 0 || availabilityType.includes('backorder'))
        ) {
          $('.js-availability-msg-personalize').removeClass('hide');
          $('.js-availability-msg-personalize').attr('aria-hidden', false);
        } else if (response.product.productType != "master") {
          $('.js-availability-msg-personalize').addClass('hide');
          $('.js-availability-msg-personalize').attr('aria-hidden', true);
        }
      }

      if ($('.global-availability').length) {
        var allAvailable = $('.product-availability')
          .toArray()
          .every(function (item) {
            return $(item).data('available');
          });

        var allReady = $('.product-availability')
          .toArray()
          .every(function (item) {
            return $(item).data('ready-to-order');
          });

        $('.global-availability')
          .data('ready-to-order', allReady)
          .data('available', allAvailable);

        $('.global-availability .availability-msg')
          .empty()
          .html(
            allReady ? response.message : response.resources.info_selectforstock
          );
      }
    });
  },
  sizeChart: function () {
    $('.dummy-size-chart-link').on('click', function (e) {
      e.preventDefault();
      $('.size-chart-container').removeClass('d-none');
      if (this.innerText === 'Size Guide') {
        this.innerText = 'Close Size Guide';
      } else {
        this.innerText = 'Size Guide';
      }
      $('.size-chart .size-chart__link').trigger('click');
    });

    $('.size-chart .size-chart__link').on('click', function (e) {
      e.preventDefault();
      var url = $(this).attr('href');
      var $prodSizeChart = $(this)
        .closest('.size-chart')
        .find('.size-chart-collapsible');
      var $sizeChartLink = $('.size-chart__link');
      if ($prodSizeChart.hasClass('active') === false) {
        $sizeChartLink.text('Close Size Guide');
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          success: function (data) {
            // Only display table element that's inside element with class 'size-chart' (size chart)
            var htmlContent = $.parseHTML(data.content);
            var miniChart = '';
            if (htmlContent.length > 0) {
              $.each(htmlContent, function (i, el) {
                if ($(el).hasClass('size-chart')) {
                  var sizeChartDiv = $(el).children('table');
                  if (sizeChartDiv.length > 0) {
                    miniChart = sizeChartDiv.wrapAll('<table>').parent().html();
                    return false;
                  }
                }
              });
            }
            $('.size-chart__content').html(miniChart);
          },
        });
      } else {
        $sizeChartLink.text('Size Guide');
        setTimeout(function () {
          $('.size-chart-container').addClass('d-none');
        }, 500);
      }
      $prodSizeChart.toggleClass('active');
    });

    $('.size-chart__button').on('click', function () {
      var $fullSizeChart = $('.size-chart-full');
      if ($fullSizeChart.length > 0) {
        $('html, body').animate({
          scrollTop: ($fullSizeChart.offset().top - (175))
        },
          500
        )
      }
    });

    $('button.js-chart-select-size-btn').on('click', function () {
      var $pdpTop = $('.product-wrapper div[data-attrname="Size"]');
      var $headerHeight = $('.main-header').outerHeight(true);

      $('html, body').animate(
        {
          scrollTop: $pdpTop.offset().top - ($headerHeight + 10),
        },
        500
      );
    });
  },
  copyProductLink: function () {
    $('body').on('click', '#fa-link', function () {
      event.preventDefault();
      var $temp = $('<input>');
      $('body').append($temp);
      $temp.val($('#shareUrl').val()).select();
      document.execCommand('copy');
      $temp.remove();
      $('.copy-link-message').attr('role', 'alert');
      $('.copy-link-message').removeClass('d-none');
      setTimeout(function () {
        $('.copy-link-message').addClass('d-none');
      }, 3000);
    });
  },

  yotpoReplacements: function () {
    $('body').on(
      'click',
      '.write-question-review-button-text, .write-question-review-button',
      function () {
        $('.name-input label.y-label').text('Name:');
      }
    );

    $('body').on('click', '.js-scrollToReviews', function () {
      if ($('#reviewsSection').length > 0) {
        $('html, body').animate(
          {
            scrollTop: $('#reviewsSection').offset().top,
          },
          500
        );
      }
    });
  },

  initVariantOptionSelection: function () {
    if (
      $('.product-detail').length &&
      $('.product-detail').data('type') === 'variant' &&
      $('.js-mainOptions .product-option').length
    ) {
      var attrs = $('.js-attributes .main-product .js-attribute');

      $.each(attrs, function () {
        var attr = $(this);
        var attrName = $(this).data('attrname');
        var attrValue = attr.find('.variant-value.selected').data('attr-value');

        if (attrName && attrValue) {
          attrName = attrName.toLowerCase();
          attrValue = attrValue.toString().toUpperCase();
          var option = $(
            '.js-mainOptions .product-option[data-option-id="' + attrName + '"]'
          );
          if (option) {
            option
              .find(
                '.options-select option[data-value-id="x' + attrValue + '"]'
              )
              .attr('selected', true)
              .trigger('change');
          }
        }
      });
    }
  },
  initProductTilejs: function () {
    initProductTilejs();
  },
  initPDPaddButtonSticky: function () {
    // var buttonDOMheight = $('.prod-addToBag-wrapper').outerHeight(true);
    // $(window).scroll(function () {
    //   var openModal = $('body').hasClass('modal-open');

    //   var headerBrandxTop = ((!$('.main-header').hasClass('visible')) && $(window).width() < 768 ? 0 : (($('.header-brands-logo-bar').length ? $('.header-brands-logo-bar').outerHeight() : 0)
    //     + ($('.header-top-bar').length ? $('.header-top-bar').outerHeight() : 0)));

    //   if ((($(window).scrollTop() + headerBrandxTop) >= $('.content-bottom').offset().top) && (!openModal)) {
    //     $('.content-bottom .prod-addToBag-wrapper').css({ "position": "fixed", "top": headerBrandxTop + "px" });
    //     $('.main-header nav').css("visibility", "hidden");
    //     $('.content-bottom .prod-addToBag-wrapper').addClass('container pdp-main-container');
    //     $('.content-bottom .add-to-cart-cta').addClass('sticky-cta');
    //     $('.content-bottom .sticky-hoverTitle').show();
    //     $('.prod-addToCart-placeholder').css("height", buttonDOMheight);
    //     if ($('.js-pdpQtyError').length) {
    //       $('.pdp-gallery-section').addClass('extended-top');
    //     }
    //   } else {
    //     $('.content-bottom .prod-addToBag-wrapper').removeClass('container pdp-main-container');
    //     $('.main-header nav').removeAttr('style');
    //     $('.content-bottom .add-to-cart-cta').removeClass('sticky-cta');
    //     $('.content-bottom .sticky-hoverTitle').hide();
    //     $('.content-bottom .prod-addToBag-wrapper').removeAttr('style');
    //     $('.prod-addToCart-placeholder').removeAttr('style');
    //     $('.pdp-gallery-section').removeClass('extended-top');
    //   }
    // })
  }
};
